export default "__VITE_ASSET__2f554adc__"